import React from 'react';
import NumberedSection from './NumberedSection'; // Import the NumberedSection component

const ServicesSection = () => {
  return (
    <div className="bg-slate-950">
      {/* Updated Services Header with centered text and a unique underline */}
      <div className="bg-white py-12 px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-5xl font-bold text-amber-400 mb-2">
            Services
          </h2>
          <div className="unique-line-small bg-amber-400 mx-auto w-24 h-1 rounded-full mb-6"></div>
          <p className="text-slate-700 text-lg max-w-xl mx-auto">
            We provide a wide range of services to ensure your car rental experience is flawless, from booking to beyond.
          </p>
        </div>
      </div>

      {/* Numbered List Section */}
      <NumberedSection />

    </div>
  );
};

export default ServicesSection;